import { QUEUE_SORTS, QUEUE_SORT_DESCRIPTIONS, QUEUE_SORT_LABELS, type QueueSort } from '@easyhelp/shared';
import InputAdornment from '@mui/material/InputAdornment';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { QUEUE_TOOLBAR_WIDTHS } from './toolbar-widths';

interface QueueSortSelectProps {
  value: QueueSort;
  onChange: (sort: QueueSort) => void;
}

/**
 * «Ordina per» della coda (story #47; ordinamenti in `QUEUE_SORTS` di `@easyhelp/shared`). Ogni voce
 * del menu dice che cosa fa; il campo chiuso mostra solo l'etichetta dell'ordinamento, preceduta da
 * «Ordina per» dentro il campo: come i filtri della barra non ha l'etichetta sopra (resterebbe più alto
 * degli altri), ma il valore da solo non direbbe che è un ordinamento. «Ordina per» è anche il nome
 * accessibile. Non è un filtro: «Azzera filtri» non lo tocca. Larghezza fissa da `sm`; sotto va a tutta
 * larghezza, sotto «Azzera filtri» quando accanto non ci sta.
 */
export function QueueSortSelect({ value, onChange }: QueueSortSelectProps) {
  return (
    <TextField
      select
      size="small"
      value={value}
      onChange={(event) => onChange(event.target.value as QueueSort)}
      sx={{
        width: { sm: QUEUE_TOOLBAR_WIDTHS.sort },
        flex: { xs: `1 0 ${QUEUE_TOOLBAR_WIDTHS.sort - 32}px`, sm: '0 0 auto' },
      }}
      slotProps={{
        select: { renderValue: (selected) => QUEUE_SORT_LABELS[selected as QueueSort] },
        htmlInput: { 'aria-label': 'Ordina per' },
        input: {
          startAdornment: (
            <InputAdornment position="start" sx={{ mr: 1 }} disablePointerEvents>
              <Typography variant="body2" component="span" color="text.secondary">
                Ordina per
              </Typography>
            </InputAdornment>
          ),
        },
      }}
    >
      {QUEUE_SORTS.map((sort) => (
        <MenuItem key={sort} value={sort}>
          <ListItemText primary={QUEUE_SORT_LABELS[sort]} secondary={QUEUE_SORT_DESCRIPTIONS[sort]} />
        </MenuItem>
      ))}
    </TextField>
  );
}
